import React from "react";
import { BsStarFill } from "react-icons/bs";
import { FaQuoteLeft } from "react-icons/fa";

export const Testimonail = () => {
  const testimonials = [
    {
      id: 1,
      name: "Léa Herrera",
      image:
        "https://images.pexels.com/photos/5325840/pexels-photo-5325840.jpeg?q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=940&w=940",
      text: "Using Zam-chain Advanced Investment as a young person have introduced me into the world of investment and compounding interest, a large percentage of my income goes into investment, and I can't be prouder of myself.",
      rating: 5,
    },
    {
      id: 2,
      name: "Merry Douglas",
      image:
        "https://images.pexels.com/photos/5325893/pexels-photo-5325893.jpeg?q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=940&w=940",
      text: "Zam-chain Advanced Investment is amongst the top three investment platform out there, apart from being easy to use, I have been able to gain more passive income and pay tuition fees for my kids.",
      rating: 5,
    },
    {
      id: 3,
      name: "James Mitchell",
      image:
        "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=940&w=940",
      text: "I've been investing with Zam-chain Advanced Investment for over two years now. The consistent returns and professional service have exceeded my expectations. It's helped me build a solid financial foundation for my retirement.",
      rating: 5,
    },
    {
      id: 4,
      name: "Sarah Chen",
      image:
        "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?q=80&fm=jpg&crop=faces&cs=tinysrgb&fit=crop&h=940&w=940",
      text: "As a busy entrepreneur, I needed an investment platform that was reliable and didn't require constant monitoring. Zam-chain Advanced Investment has been perfect for my needs, delivering steady profits while I focus on my business.",
      rating: 5,
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <div className="w-8 h-0.5 bg-primary mr-3"></div>
            <span className="text-2xl text-primary font-medium">
              Testimonials
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-gray-800">
            What Our Clients Say
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-xl shadow p-8 relative"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 left-8">
                <div className="bg-primary rounded-full p-3">
                  <FaQuoteLeft className="text-white text-lg" />
                </div>
              </div>

              {/* Content */}
              <div className="pt-6">
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, index) => (
                    <BsStarFill
                      key={index}
                      className="text-yellow-400 text-sm"
                    />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-600 font-body leading-relaxed mb-6">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="font-heading font-medium text-gray-800">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-gray-500">Verified Client</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
